import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import BidNotifierData from 'static/script/app/data/bid-notifier';
import formatNumber from 'static/script/utils/format-number';

function Realtime() {
    this.defaultAttrs({
        initData: null
    });

    this._register = function() {
        let itemIds = this.$node.find('[data-item-id]').map(function() {
            return $(this).attr('data-item-id');
        }).get();
        BidNotifierData.attachTo(document, {
            itemId: itemIds,
            buyingEventPusherServerUrl: this.attr.initData.pageSpecificData.BuyingEventPusherServerUrl,
            buyingEventPusherEnabled: this.attr.initData.pageSpecificData.BuyingEventPusherEnabled,
            featureSwitches: this.attr.initData.featureSwitches
        });
    };

    this._flash = function (itemCard) {
        let highlightee = itemCard.find('[data-item-card-details-price]');
        highlightee.addClass('highlight');
        setTimeout(function() {
            highlightee.removeClass('highlight');
        }, 1000);
    };

    this._updateBid = function(evt, data) {
        let item = this.$node.find('[data-item-id=' + data.AuctionId + ']');
        item.find('[data-item-card-details-price]').text(formatNumber.asMoney(data.BidAmount) + ' kr');
        item.find('[data-item-card-details-bids]').text(data.NumberOfBids + ' bud');
        this._flash(item.find('[data-item-card-body]'));
    };

    this._handleItemEnded = function(evt, data) {
        let item = this.$node.find('[data-item-id=' + data.ItemId + ']');
        item.find('[data-item-card-details-time-left]').text('Avslutad');
        //setTimeout(function() {
        //    item.remove();
        //}, 5000);
    };

    this.after('initialize', function () {
        if (this.attr.initData.pageSpecificData &&
            this.attr.initData.pageSpecificData.BuyingEventPusherServerUrl &&
            this.attr.initData.pageSpecificData.BuyingEventPusherEnabled) {

            this._register();
            this.on(document, 'data:notifications:on-bid-update', this._updateBid);
            this.on(document, 'data:notifications:on-item-sold', this._handleItemEnded);
            this.on(document, 'data:notifications:on-item-unsold', this._handleItemEnded);
        }
    });
}

export default defineComponent.component(Realtime);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/realtime.js